import LongButton from "components/common/button/long-button.tsx";
import BlockyBoldText from "components/custom-texts/blocky-bold-text.tsx";

interface CommerceButtonProps {
  onClick: () => void;
  disabled: boolean;
  processing?: boolean;
  actionType: 'deposit' | 'withdraw';
  amount?: number;
}

const CommerceButton = ({ 
  onClick, 
  disabled, 
  processing, 
  actionType, 
  amount 
}: CommerceButtonProps) => {
  const getButtonText = () => {
    const action = actionType === 'deposit' ? 'Deposit' : 'Withdraw';
    return amount ? `${action} $${amount}` : action;
  };

  return (
    <LongButton
      onClick={onClick}
      disabled={disabled || processing}
    >
      <BlockyBoldText>{getButtonText()}</BlockyBoldText>
    </LongButton>
  );
};

export default CommerceButton; 